import React from "react";
import "./styles.css";
import "../styles.css";
import { MOBILE_OS, AJJAS_PLAY_STORE_LINK, AJJAS_APP_STORE_LINK } from "../../../Library/constants";
import { getMobileOperatingSystem } from "../../../Library/helpers";
import { ScanToContact, AjjasLogo } from "../../../Assets/images/svgs";
import config from "../../../config";
import { logFirebaseEvent } from "../../../firebase/logEventHelper";
const { redirectUrl } = config;

const REDIRECT_CS_PATH = "/webapp/cs";
const ACTIVATION_STEPS = [
  "Download the app & sign in to your Ajjas account",
  "Peel the sticker and scan QR using Ajjas App",
  "Enter your vehicle details",
  "Voila! you’re all set :)",
];

const ActivateContactSticker = () => {
  const isAndroid = getMobileOperatingSystem() === MOBILE_OS.ANDROID;
  const isIos = getMobileOperatingSystem() === MOBILE_OS.IOS;

  const storeLink = isAndroid ? AJJAS_PLAY_STORE_LINK : isIos ? AJJAS_APP_STORE_LINK : "#";
  const appLink = `${redirectUrl}webapptl?redirect=${REDIRECT_CS_PATH}`;

  return (
    <div className="act-cs-body">
      <div className="logo-title-cnt">
        <AjjasLogo className="logo" />
        <span className="title">Activate Your Contact Sticker</span>
      </div>
      <div className="abt-logo-cnt">
        <ScanToContact className="abt-logo" />
      </div>
      <div className="act-cs-inf-cnt">
        <ul className="timeline">
          {ACTIVATION_STEPS.map((step, index) => (
            <li key={index} className={`timelineItem ${index + 1 === ACTIVATION_STEPS.length ? "last-item" : ""}`}>
              <div className="cs-gradient-bg bullet-point"></div>
              <span className="step-inf">{step}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="btn-link-cnt">
        <a href={storeLink} onClick={() => logFirebaseEvent("DOWNLOAD_AJJAS_APP_ACT_PAGE")} target="_blank" rel="noopener noreferrer" className="cs-btn-gradient act-cs-down-btn" aria-label="Download Ajjas App" >
          Download Ajjas App
        </a>
        <div className="alr-inst">
          <span className="alr-ins">Already Installed?</span>
          <a href={appLink} onClick={() => logFirebaseEvent("GO_TO_AJJAS_APP_ACT_PAGE")} target="_blank" rel="noopener noreferrer" className="go-to-link" aria-label="Go to Ajjas App" >
            Go to Ajjas App
          </a>
        </div>
      </div>
    </div>
  );
};

export default ActivateContactSticker;